import script from "./LoadingSpinner.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingSpinner.vue3.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingSpinner.vue3.vue?vue&type=style&index=0&id=48681a9d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48681a9d"]])

export default __exports__